/* eslint-disable react/display-name */
import React from 'react';
import { Route, Switch } from 'react-router-dom';
import routes from '../routes';
import LoadingPage from '../pages/authentication/LoadingPage';

import { BrandLogoFull as BrandLogoFullIcon } from '../components/Brand';
import ModeDisplayBarLogin from '../components/ModeDisplayBar/ModeDisplayBarLogin';
import { changePageTitleModifierBrokerWise } from '../helpers/title-modifiers';
import { useEffect } from 'react';
import BrokerWiseBrokerLogo from '../partials/Authentication/BrokerWiseBrokerLogo';

const getRoutes = () => {
  return routes.map((props) => (
    <Route
      key={props.id}
      path={props.path}
      render={(p) => <props.component {...p} />}
      exact={props.exact}
      strict={props.strict}
    />
  ));
};

export default function () {
  useEffect(() => {
    changePageTitleModifierBrokerWise();
  }, []);

  return (
    <div className="authenticate">
      <div className="authenticate__page">
        <div className="authenticate__brand">
          <BrandLogoFullIcon /> <BrokerWiseBrokerLogo />
        </div>
        <ModeDisplayBarLogin />
        <React.Suspense fallback={<LoadingPage />}>
          <Switch>{getRoutes(routes)}</Switch>
        </React.Suspense>
      </div>
    </div>
  );
}
